export default __webpack_public_path__ + "static/media/SWT0770.34I-19652_-14725_0.6373675e.jpg";